import { render, staticRenderFns } from "./CatalogForm.vue?vue&type=template&id=70474ae9&"
import script from "./CatalogForm.vue?vue&type=script&lang=js&"
export * from "./CatalogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports